// extracted by mini-css-extract-plugin
export default {"plus-icon":"PlusIcon_plus-icon__njUF3"};